<template>
	<div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
		<div>
			<div class="page_header">
				<span class="page_title" style="flex: 1;float:left">
					{{ $t('drivermanagement.drivermanagement') }}</span>
				<el-form :inline="true" class="demo-form-inline" size="small" style="float: right;">
					<el-form-item :label="$t('drivermanagement.drivername')">
						<el-input v-model="driverName" :placeholder="$t('drivermanagement.inputdriver')"
							clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">{{ $t('public.query') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" @click="add">{{ $t('public.add') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" plain @click="download">{{ $t('public.export') }}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div style="background: #C5D0E2;height: 1px;margin:30px 0px">
			</div>
		</div>

		<div>
			<el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" v-loading="loading"
				style="width: 100%">

				<el-table-column :label="$t('public.index')" type="index" width="50" align="center">
				</el-table-column>
				<el-table-column prop="Driver" :label="$t('drivermanagement.driver')" width="110" align="center">
				</el-table-column>
				<el-table-column :label="$t('driverSignInOutRec.司机分组')" width="140" align="center">
					<template slot-scope="scope">
						{{ getGroupNameById(scope.row.GroupID) }}
					</template>
				</el-table-column>
				<el-table-column prop="DriverICNo" :label="$t('drivermanagement.driverICNo')" width="140"
					align="center">
				</el-table-column>
				<el-table-column prop="DriverlicenseNo" :label="$t('drivermanagement.driverlicenseNo')" width="140"
					align="center">
				</el-table-column>
				<el-table-column prop="ContactNo" :label="$t('drivermanagement.contactNo')" align="center">
				</el-table-column>
				<el-table-column prop="LicenseValidityPeriod" :label="$t('drivermanagement.licenseValidityPeriod')"
					width="140" align="center">
				</el-table-column>

				<el-table-column prop="QualificationCertificate" width="100"
					:label="$t('drivermanagement.qualificationCertificate')" align="center">
				</el-table-column>
				<el-table-column prop="QCValidityperiod" :label="$t('drivermanagement.qCValidityperiod')" width="140"
					align="center">
				</el-table-column>
				<el-table-column :label="$t('public.Operation')" align="center" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type='success' @click="modify(scope.$index, scope.row)">{{
							$t("public.edit")
						}}</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{
							$t("public.del")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination" v-show="total > 0">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
			<el-dialog class="adddriverlist" :title="drivertitle" :visible.sync="dialogFormVisible"
				:width="LanguageId == 1 ? '700px' : '930px'" :close-on-click-modal="false">
				<div class="registrationInfo">
					{{ $t("drivermanagement.basicInfo") }}
				</div>
				<el-row style="background: #FFFFFF;padding: 10px 10px;">
					<el-col :span="12">
						<div class="grid-content bg-purple">
							<el-form label-position="right" label-width="270px" :model="driverInfo" size="mini"
								:label-width="LanguageId == 1 ? '110px' : '270px'" :rules="rules" ref="driverInfo">
								<el-form-item :label="$t('drivermanagement.driver') + '：'" style="margin-top: 10px;"
									prop="Driver">
									<el-input v-model="driverInfo.Driver"
										:placeholder="$t('drivermanagement.inputdriver')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('driverSignInOutRec.司机分组')" prop="selectedValue"
									style="margin-top: 15px;">
									<div style="display: flex;align-items: center;gap: 10px;">
										<el-select v-model="level" :placeholder="$t('public.select')" size="small"
											@change="levelchangeSelect" style="width: 90px;">
											<el-option v-for="item in options" :key="item.value" :label="item.label"
												:value="item.value" />
										</el-select>

										<el-select v-model="driverInfo.selectedValue" :placeholder="$t('public.select')"
											size="small" :key="level" @change="handleSelectChange" style="flex: 1;">
											<el-option v-for="(item, index) in optionslevel[level]" :key="index"
												:label="item.label" :value="item.value" />
										</el-select>
									</div>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.employeeCardID') + '：'"
									style="margin-top: 15px;">
									<el-input v-model="driverInfo.EmployeeCardID"
										:placeholder="$t('drivermanagement.inputId')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.gender') + '：'" style="margin-top: 15px;">
									<el-select size="small" filterable v-model="driverInfo.Sex"
										:placeholder="$t('public.select')">
										<el-option v-for="item in sextype" :label="item.label" :value="item.value"
											:key="item.value"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item :label="$t('vehicle.Mobile') + '：'" prop="ContactNo"
									style="margin-top: 15px;">
									<el-input v-model="driverInfo.ContactNo"
										:placeholder="$t('operatormgr.please_opt_mobile')" maxlength='11'
										clearable></el-input>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content bg-purple-light">
							<el-form label-position="right" :model="driverInfo" size="mini"
								:label-width="LanguageId == 1 ? '110px' : '270px'">
								<el-form-item :label="$t('drivermanagement.employeeno') + '：'"
									style="margin-top: 10px;">
									<el-input v-model="driverInfo.EmployeeCardNo"
										:placeholder="$t('drivermanagement.inputemployeeCarNo')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.driverNo') + '：'" style="margin-top: 15px;">
									<el-input v-model="driverInfo.DriverWorkNo"
										:placeholder="$t('drivermanagement.inputdriverNo')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('state.title') + '：'" style="margin-top: 15px;">
									<el-select size="small" filterable v-model="newstatus"
										:placeholder="$t('public.select')">

										<el-option v-for="item in driverStatus" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label="$t('drivermanagement.icNo') + '：'" style="margin-top: 15px;">
									<el-input v-model="driverInfo.DriverICNo"
										:placeholder="$t('drivermanagement.inputicNo')" clearable
										oninput="if(value.length>11)value=value.slice(0,11)"
										onkeyup="this.value = this.value.replace(/[^\d]/g,'');"></el-input>
								</el-form-item>

							</el-form>
						</div>
					</el-col>
					<el-form :inline="true" :model="driverInfo" class="demo-form-inline" label-position="right"
						:label-width="LanguageId == 1 ? '110px' : '270px'" style="margin-top: 10px;">
						<el-form-item :label="$t('operatormgr.opt_addr') + '：'" style="margin-top: 15px;">
							<el-input type="textarea" v-model="driverInfo.HomeAddress" maxlength="100" show-word-limit
								:placeholder="$t('operatormgr.please_opt_addr')" clearable></el-input>
						</el-form-item>

						<el-form-item :label="$t('drivermanagement.driverProfile') + '：'">
							<el-input type="textarea" v-model="driverInfo.DriverProfile" maxlength="400" show-word-limit
								:placeholder="$t('drivermanagement.inputdriverProfile')" clearable></el-input>
						</el-form-item>
					</el-form>

				</el-row>

				<div class="registrationInfo">
					{{ $t('drivermanagement.driverInfo') }}
				</div>
				<el-row style="background: #FFFFFF;padding: 10px 10px;">
					<el-col :span="12">
						<el-form label-position="right" :model="driverInfo" size="mini"
							:label-width="LanguageId == 1 ? '130px' : '270px'">
							<el-form-item :label="$t('drivermanagement.licenseissunit') + '：'"
								style="margin-top: 10px;">
								<el-input v-model="driverInfo.LicenseIssuingUnit"
									:placeholder="$t('drivermanagement.licenseissunit')" clearable></el-input>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.authorizeddriver') + '：'"
								style="margin-top: 10px;">
								<el-select size="small" filterable v-model="quasiDrivingType"
									:placeholder="$t('public.select')">
									<el-option v-for="item in vehicletype" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.qualification') + '：'" style="margin-top: 10px;">
								<el-input v-model="driverInfo.QualificationCertificate"
									:placeholder="$t('drivermanagement.inputqualification')" clearable></el-input>
							</el-form-item>
						</el-form>

					</el-col>
					<el-col :span="12">
						<el-form label-position="right" :model="driverInfo" size="mini"
							:label-width="LanguageId == 1 ? '130px' : '270px'">
							<el-form-item :label="$t('drivermanagement.licenseValidityPeriod') + '：'"
								style="margin-top: 10px;">
								<el-date-picker type="date"
									:placeholder="$t('drivermanagement.inputlicenseValidityPeriod')"
									value-format="yyyy-MM-dd" v-model="driverInfo.LicenseValidityPeriod"
									style="width: 100%;"></el-date-picker>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.driverlicenseNo') + '：'"
								style="margin-top: 10px;">
								<el-input v-model="driverInfo.DriverlicenseNo"
									:placeholder="$t('drivermanagement.inputdriverlicenseNo')" clearable></el-input>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.dateofcertificate') + '：'"
								style="margin-top: 10px;">
								<el-date-picker type="date" :placeholder="$t('public.select')" value-format="yyyy-MM-dd"
									v-model="driverInfo.QCValidityperiod" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<div slot="footer" class="dialog-footer" style="text-align: right;">
					<el-button size="small" @click="dialogFormVisible = false">{{ $t('public.cancel') }}</el-button>
					<el-button size="small" type="primary"
						@click="determine('driverInfo')">{{ $t('public.confirm') }}</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import language from '@/utils/getLanguageId';
	import {
		mapState
	} from 'vuex'
	import rules from '@/utils/rules'

	export default {
		name: "driverManagement",
		data() {
			return {
				level: 0,
				loading: false,
				total: 0,
				LanguageId: 1,
				quasiDrivingType: 0,
				drivertitle: this.$t('drivermanagement.adddriver'),
				dialogFormVisible: false,
				driverName: "",
				tableData: [],
				sextype: [{
						value: 0,
						label: this.$t('drivermanagement.female')
					},
					{
						value: 1,
						label: this.$t('drivermanagement.male')
					},
				],
				driverStatus: [{
						value: 0,
						label: this.$t('drivermanagement.onthejob')
					},
					{
						value: 1,
						label: this.$t('drivermanagement.quit')
					}, {
						value: 2,
						label: this.$t('drivermanagement.retire')
					}
				],
				vehicletype: [{
					value: 0,
					label: this.$t('drivermanagement.largebus')
				}, {
					value: 1,
					label: this.$t('drivermanagement.citybus')
				}, {
					value: 2,
					label: this.$t('drivermanagement.mediumbus')
				}, ],
				driverInfo: {
					selectedValue: "",
					Sex: 1
				},
				currentPage: 1,
				pageSize: 10,
				driverID: 0,
				vehicles: [],
				newstatus: "",
				rules: {
					Driver: [{
						required: true,
						message: this.$t('vehicleInfo.inputdrivername'),
						trigger: 'blur'
					}],
					GroupID: [{
						required: true,
						message: this.$t('drivermanagement.selectbranch'),
						trigger: 'change'
					}],
					ContactNo: [{
						pattern: /^1[3456789]\d{9}$/,
						message: this.$t('drivermanagement.inputphone'),
						trigger: "blur"
					}],
					selectedValue: [{
						required: true,
						message: this.$t('public.select'),
						trigger: 'change'
					}]
				},
				options: [{
						value: 0,
						label: this.$t("organstructure.headoffice"),
					},
					{
						value: 1,
						label: this.$t("organstructure.branch"),
					},
					{
						value: 2,
						label: this.$t("runState.fleet"),
					},
					{
						value: 3,
						label: this.$t("runState.route"),
					},
				],
				selectedArray: [],
				optionslevel: [
					[],
					[],
					[],
					[]
				],
				selectedValue: "",
				vehicleTreeList: [],
			}
		},
		mounted() {
			var that = this;
			that.LanguageId = language(that.$store.getters.locale)
			window.onresize = () => {
				return (() => {
					window.fullWidth = document.documentElement.clientWidth;
					that.fullWidth = window.fullWidth;
				})();
			};

			// 初始时加载所有级别的数据
			that.loadAllLevelOptions().then(() => {
				that.level = 0;
			});

			that.queryDriverInfo(0);
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				newvehicles: state => state.app.vehicles,
				token: state => state.user.token
			}),
		},
		methods: {
			// 切换级别选择
			// 切换级别选择
			levelchangeSelect(val) {
				this.level = val;
				const currentSelectedValue = this.driverInfo.selectedValue;

				// 如果当前级别的选项已经加载过了，直接使用
				if (this.optionslevel[val] && this.optionslevel[val].length > 0) {
					// 如果切换级别后，当前选中的值不在新级别的选项中，清空选中
					if (currentSelectedValue) {
						const exists = this.optionslevel[val].some(item => item.value === currentSelectedValue);
						if (!exists) {
							this.driverInfo.selectedValue = "";
						}
					}
				} else {
					// 如果当前级别没有数据，加载数据
					this.loadCurrentLevelData(val, currentSelectedValue);
				}
			},
			// 加载当前级别的数据
			loadCurrentLevelData(level, currentSelectedValue) {
				this.$api.queryVehicleTreeInfo({
					OperatorID: this.$store.getters.operator.OperatorId,
					CompanyID: this.$store.getters.operator.CompanyId
				}).then(res => {
					var newvehicles = res.vehicles;

					// 只清空当前级别的数据
					this.optionslevel[level] = [];

					newvehicles.forEach(element => {
						if (level == 0 && element.treeLevel == 1) {
							this.optionslevel[0].push({
								value: element.id,
								label: element.name
							});
						} else if (level == 1 && element.treeLevel == 2) {
							this.optionslevel[1].push({
								value: element.id,
								label: element.name
							});
						} else if (level == 2 && element.treeLevel == 3) {
							this.optionslevel[2].push({
								value: element.id,
								label: element.name
							});
						} else if (level == 3 && element.treeLevel == 4) {
							this.optionslevel[3].push({
								value: element.id,
								label: element.name
							});
						}
					});

					// 如果切换级别后，当前选中的值不在新级别的选项中，清空选中
					if (currentSelectedValue) {
						const exists = this.optionslevel[level].some(item => item.value === currentSelectedValue);
						if (!exists) {
							this.driverInfo.selectedValue = "";
						}
					}
				});
			},
			// 处理选择变化
			handleSelectChange(value) {
				this.driverInfo.selectedValue = value;
				// 触发表单验证
				if (this.$refs.driverInfo) {
					this.$refs.driverInfo.validateField('selectedValue');
				}
			},

			handleSizeChange(val) {
				this.pageSize = val;
				this.queryDriverInfo(0);
			},

			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryDriverInfo(0);
			},

			onSubmit() {
				this.queryDriverInfo(0);
			},
			// 新增司机
			add() {
				this.driverInfo = {
					selectedValue: "",
					Sex: 1,
					LicenseValidityPeriod: new Date().toISOString().split('T')[0],
					QCValidityperiod: new Date().toISOString().split('T')[0]
				};
				this.drivertitle = this.$t('drivermanagement.adddriver');
				this.dialogFormVisible = true;
				this.newstatus = "";
				this.quasiDrivingType = 0;
				this.level = 0;

				// 新增时也需要加载所有级别的数据
				this.loadAllLevelOptions().then(() => {
					// 加载完成后，再设置默认级别
					this.level = 0;
				});

				this.$nextTick(() => {
					if (this.$refs["driverInfo"]) {
						this.$refs["driverInfo"].clearValidate();
					}
				});
			},

			// 修改司机信息
			modify(index, row) {
				this.drivertitle = this.$t('drivermanagement.modifydriverinfo');
				this.driverID = row.DriverID;
				this.dialogFormVisible = true;

				// 先重置数据
				this.level = 0;
				this.newstatus = row.Status;
				this.quasiDrivingType = row.QuasiDrivingType || 0;

				// 深拷贝行数据
				this.driverInfo = {
					...JSON.parse(JSON.stringify(row)),
					selectedValue: row.GroupID || ""
				};

				// 保存原始的GroupID用于后续匹配
				const originalGroupId = row.GroupID || "";

				// 先加载所有级别的数据
				this.loadAllLevelOptions().then(() => {
					// 数据加载完成后，匹配并设置级别
					this.autoMatchLevel(originalGroupId);
				});

				this.$nextTick(() => {
					if (this.$refs.driverInfo) {
						this.$refs.driverInfo.clearValidate();
					}
				});
			},
			// 加载所有级别的选项
			loadAllLevelOptions() {
				return new Promise((resolve, reject) => {
					this.$api.queryVehicleTreeInfo({
						OperatorID: this.$store.getters.operator.OperatorId,
						CompanyID: this.$store.getters.operator.CompanyId
					}).then(res => {
						var newvehicles = res.vehicles;
						this.vehicleTreeList = newvehicles;
						// 先清空所有选项
						this.optionslevel = [
							[],
							[],
							[],
							[]
						];

						// 一次性加载所有级别的数据
						newvehicles.forEach(element => {
							if (element.treeLevel == 1) {
								this.optionslevel[0].push({
									value: element.id,
									label: element.name
								});
							} else if (element.treeLevel == 2) {
								this.optionslevel[1].push({
									value: element.id,
									label: element.name
								});
							} else if (element.treeLevel == 3) {
								this.optionslevel[2].push({
									value: element.id,
									label: element.name
								});
							} else if (element.treeLevel == 4) {
								this.optionslevel[3].push({
									value: element.id,
									label: element.name
								});
							}
						});

						resolve();
					}).catch(error => {
						console.error("加载组织架构失败:", error);
						// 即使出错也要resolve，避免界面卡住
						resolve();
					});
				});
			},
			// 通过GroupID获取组织名称
			getGroupNameById(groupId) {
				if (!groupId || !this.vehicleTreeList.length) return '';
				const item = this.vehicleTreeList.find(node => node.id == groupId);
				return item ? item.name : groupId;
			},
			// 自动匹配级别
			autoMatchLevel(groupId) {
				if (!groupId) {
					this.level = 0;
					this.driverInfo.selectedValue = "";
					return;
				}

				// 查找目标值在哪一级
				let matchedLevel = -1;
				for (let i = 0; i < this.optionslevel.length; i++) {
					const found = this.optionslevel[i].find(item => item.value == groupId);
					if (found) {
						matchedLevel = i;
						break;
					}
				}

				if (matchedLevel !== -1) {
					this.level = matchedLevel;
					this.driverInfo.selectedValue = groupId;

					// 确保下拉框有正确的选项
					this.$nextTick(() => {
						// 重新加载当前级别的选项
						this.levelchangeSelect(matchedLevel);
					});
				} else {
					// 如果没找到，默认为0级
					this.level = 0;
					this.driverInfo.selectedValue = "";
					this.levelchangeSelect(0);
				}
			},

			handleDelete(index, row) {
				this.driverID = row.DriverID;
				this.$confirm(this.$t('drivermanagement.isdelete'), this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText: this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					this.saveDriverInfo(this.driverID, 3, this.$t('public.hasDeleted'));
				}).catch(() => {
					// 取消删除
				});
			},

			queryDriverInfo(type) {
				var that = this;
				this.loading = true;
				that.$api.queryDriverInfo({
					CompanyID: that.operator.CompanyId,
					CarNo: "",
					DriverName: that.driverName,
					PageNo: that.currentPage,
					PageSize: that.pageSize,
					OperatorID: that.operator.OperatorId,
					IsExport: type,
				}).then((res) => {
					this.loading = false
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								that.total = parseObj.count;
								if (parseObj.data.length > 0) {
									that.tableData = parseObj.data;
								} else {
									that.tableData = [];
								}
							}
						}
					} else {
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						});
						var driverinfotitle = that.$t('drivermanagement.driverlist') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download", driverinfotitle);
						a.click();
						window.URL.revokeObjectURL(blob);
					}
				})
			},

			download() {
				this.queryDriverInfo(1);
			},

			determine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.drivertitle == this.$t('drivermanagement.adddriver')) {
							this.saveDriverInfo(-1, 1, this.$t('public.add_success'));
						} else if (this.drivertitle == this.$t('drivermanagement.modifydriverinfo')) {
							this.saveDriverInfo(this.driverID, 2, this.$t('public.edit_success'));
						}
					}
				});
			},

			saveDriverInfo(driverID, type, message) {
				var that = this;
				that.$api.saveDriverInfo({
					DriverID: driverID,
					Driver: that.driverInfo.Driver,
					GroupID: that.driverInfo.selectedValue,
					EmployeeCardNo: that.driverInfo.EmployeeCardNo,
					DriverWorkNo: that.driverInfo.DriverWorkNo,
					EmployeeCardID: that.driverInfo.EmployeeCardID,
					Status: that.newstatus,
					LicenseIssuingUnit: that.driverInfo.LicenseIssuingUnit,
					LicenseValidityPeriod: that.driverInfo.LicenseValidityPeriod,
					QualificationCertificate: that.driverInfo.QualificationCertificate,
					QCValidityperiod: that.driverInfo.QCValidityperiod,
					ContactNo: that.driverInfo.ContactNo,
					DriverICNo: that.driverInfo.DriverICNo,
					Sex: that.driverInfo.Sex,
					DriverlicenseNo: that.driverInfo.DriverlicenseNo,
					QuasiDrivingType: that.quasiDrivingType,
					HomeAddress: that.driverInfo.HomeAddress,
					DriverProfile: that.driverInfo.DriverProfile,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						that.dialogFormVisible = false;
						that.$message({
							type: 'success',
							message: message
						});
						let newPageing = Math.ceil((this.tableData.length - 1) / this
							.pageSize);
						let newcurrentPage = this.currentPage > newPageing ? newPageing : this
							.currentPage;
						this.currentPage = newcurrentPage < 1 ? 1 : newcurrentPage;
						that.queryDriverInfo(0);
						that.driverInfo = {};
					} else {
						that.$message({
							type: 'info',
							message: this.$t('public.SaveFail')
						});
					}
				})
			},

			// 时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp);
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.adddriverlist {
		::v-deep .el-dialog {
			background: #EEEEEE;
		}
	}

	.registrationInfo {
		margin-top: 10px;
		font-size: 12px;
		text-align: left;
		font-weight: bold !important;
		margin-left: 20px;
		color: black;
		margin-bottom: 10px;
	}

	.adddriverlist {
		::v-deep.el-form-item__label {
			font-size: 12px;
		}
	}

	.adddriverlist {
		::v-deep .el-textarea__inner {
			width: 410px;
			font-size: 12px;
		}
	}
	.adddriverlist {
	  ::v-deep .el-select .el-input__inner {
	    text-overflow: ellipsis;
	    overflow: hidden;
	    white-space: nowrap;
	  }
	  ::v-deep .el-select-dropdown__item {
	    text-overflow: ellipsis;
	    overflow: hidden;
	    white-space: nowrap;
	  }
	}
</style>